module.exports = __webpack_public_path__ + "img/cc.288f78a8.svg";